export default "__VITE_ASSET__DtyXqLq___"